import { CheckCircle2, Loader2 } from "lucide-react";
import { RunElapsed } from "@/components/atoms/testing/RunElapsed";

/**
 * "What is happening right now" banner shown above a live feed.
 *
 * Single home for this component — it previously existed as an exported copy in ExecutionFeed and a
 * private copy in ChatSseActivity. Both rendered the same markup; only one was maintained.
 */
export function RunningStepBanner({
	title,
	active,
	stepNum,
	startedAt,
}: {
	title: string;
	active: boolean;
	stepNum?: number;
	startedAt?: number | null;
}) {
	return (
		<div className="relative overflow-hidden rounded-md border border-primary/40 bg-primary/10 px-3 py-2 text-xs">
			{active && (
				<div
					data-tst-decorative-motion
					className="pointer-events-none absolute inset-0 -translate-x-full animate-[shimmer_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-primary/25 to-transparent"
				/>
			)}
			<div className="relative flex items-center gap-2">
				{active ? (
					<Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-primary" />
				) : (
					<CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-success-strong" />
				)}
				{stepNum != null && stepNum > 0 && (
					<span className="shrink-0 rounded bg-primary/20 px-1.5 py-0.5 font-mono text-[11px] font-semibold text-primary">
						Step {stepNum}
					</span>
				)}
				<span className="min-w-0 truncate font-medium text-foreground/90">{title}</span>
				{active && (
					<span className="ml-auto flex shrink-0 items-center gap-2">
						{startedAt != null && <RunElapsed startedAt={startedAt} />}
						<span className="flex items-center gap-1 text-[11px] text-primary">
							<span
								data-tst-decorative-motion
								className="h-1.5 w-1.5 animate-ping rounded-full bg-primary"
							/>
							live
						</span>
					</span>
				)}
			</div>
		</div>
	);
}
